/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Payin admin
 * Payin application
 * OpenAPI spec version: 1.0
 */

export enum PayinCommonTicketV1Priority {
    PRIORITY_UNSPECIFIED = 'PRIORITY_UNSPECIFIED',
    PRIORITY_HIGH = 'PRIORITY_HIGH',
    PRIORITY_MEDIUM = 'PRIORITY_MEDIUM',
    PRIORITY_LOW = 'PRIORITY_LOW',
}
